import { Branding } from "../../../types/Branding";
import { UserConfig } from "../../../types/UserConfig";
import {initGTM} from "../../../analytics/util/analyticUtil";

export class GameConversionEventService {

    public static id = "gameConversionEventService";

    /** @ngInject */
    public constructor(private userConfig: UserConfig) {
    }

    public sendConversionEvent() {
        if (this.userConfig.branding === Branding.GAME) {
            initGTM("GTM-KCQSGP3");
        }
    }

}
